import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const handleCategoryClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <span className="text-2xl font-heading text-primary-600">韩漫大全</span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-900'
              }`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              首页
            </Link>
            {categories.slice(0, 6).map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-900'
                }`}
              >
                {cat.name}
              </button>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-900'
              }`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <div className="relative hidden sm:block">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 pl-9 pr-4 py-2 rounded-full bg-background-100 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
            </div>
            <button
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl text-foreground-700 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className="block w-full text-left px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
              >
                {cat.name}
              </button>
            ))}
            <Link
              to="/about"
              className="block px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}